
// apiEndpoint & emApplicationtoken are overriden by Magnolia components.
// Values come from Dynamics > Settings > Web applications
export const environment = {
  production: true,
  buildVersion: require('../../package.json').version,
  apiEndpoint: 'https://50b1a68ea4d04e2185cdf81db2257bc8.svc.dynamics.com/EvtMgmt/api/v2.0/',
  localizationEndpoint: 'assets/Localization/',
  imagesEndpoint: 'assets/images/',
  eventtypeid: '',
  useRestStack: true,
  emApplicationtoken: '',
  isAuthenticationEnabled: true,
  useAadB2C: true,
  aadB2CConfig: {
    authorityHost: 'ti8mevents.b2clogin.com',
    tenant: 'ti8mevents.onmicrosoft.com',
    clientID: '7eb54f43-0ed3-4e3f-b95a-a246a7c5b463',
    signUpSignInPolicy: 'B2C_1_MarketingEvents',
    passwordResetPolicy: 'B2C_1_Marketing_PasswordReset',
    b2cScopes: ['https://ti8mevents.onmicrosoft.com/events/registration'],
    redirectUri: ''
  },
  useMockData: false,
  usePreview: false,
  internalEventPage: '',
  beServer: 'http://dynamic-events-be:8070'
};
